import React from 'react';
import type { Step } from '../../types';

import exclamationIcon from '../../assets/icons/exclamation.svg?raw&inline';
import checkIcon from '../../assets/icons/check.svg?raw&inline';

export const KybStepItem: React.FC<KybStepItemProps> = ({
  hasLine,
  hideNumber,
  index,
  step,
  current,
}) => {
  const handleStepStatus = () => {
    let className = 'kyb-step ';

    if (hasLine) className += 'has-line ';
    if (step.status === 'pending' && current) className += 'current';
    else if (step.status === 'completed') className += 'completed';

    return className;
  };

  const itemTextClass = () => {
    let className = 'form-label text-dark size-14 mb-0';

    if (hideNumber || current || step.status === 'completed') {
      className += ' font-weight-600';
    }

    return className;
  };

  return (
    <div className="col-12" style={{ marginBottom: hideNumber ? 10 : 33 }}>
      <div className="align-self-center">
        <div className="d-flex">
          {!hideNumber && <span className={handleStepStatus()}>{index + 1}</span>}
          <span className={itemTextClass()}>{step.label}</span>
          {step.status === 'completed' && (
            <span 
              className="d-flex align-items-center text-success ms-2" 
              dangerouslySetInnerHTML={{ __html: checkIcon }} 
            />
          )}
          {step.status === 'declined' && (
            <span 
              className="d-flex align-items-center text-danger ms-2" 
              dangerouslySetInnerHTML={{ __html: exclamationIcon }} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

interface KybStepItemProps {
  index: number;
  step: Step;
  current: boolean;
  hasLine: boolean;
  hideNumber: boolean;
}
